import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import CommonContainer, { SIZE_HALF } from '../common/CommonContainer';
import { HOME_REDIRECT_URL, LONG_REDIRECT_TIME } from '../../utils/redirect-const';
import CommonCenterContainer from '../common/CommonCenterContainer';

const ResetPasswordSuccess = () => {
  const navigate = useNavigate();
  const [redirect, setRedirect] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setRedirect(true);
      navigate(HOME_REDIRECT_URL);
    }, LONG_REDIRECT_TIME);
    return () => clearTimeout(timer);
  }, [navigate]);

  if (redirect) {
    return null;
  }

  return (
    <CommonCenterContainer>
      <CommonContainer size={SIZE_HALF}>
        <Typography paragraph variant="h5">
          Your password reset request has been successfully registered.
        </Typography>
        <Typography paragraph>
          Password change link has been sent to the email address assigned to the requested account. Please follow the
          guidelines in the received message.
        </Typography>
        <Typography>
          You will be automatically redirected to the home page.
        </Typography>
        <Typography>
          If you have not been redirected automatically, please <Link to={HOME_REDIRECT_URL}>click here</Link>.
        </Typography>
      </CommonContainer>
    </CommonCenterContainer>
  );
};

ResetPasswordSuccess.propTypes = {
  history: PropTypes.object,
};

export default ResetPasswordSuccess;
